import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const Toggle = forwardRef(({ onClick }, ref) => (
  <a
    href="# "
    className="text-decoration-none"
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    Insert saved reply
  </a>
));

Toggle.propTypes = {
  onClick: PropTypes.func,
};

export default Toggle;
